import loadable from '@loadable/component';
import servicesPageQuery from './query.graphql';

const Services = loadable(() =>
  import(/* webpackChunkName: "services" */ './components/services')
);

Services.graphQL = servicesPageQuery;

Services.loadOrder = [{}];

Services.variables = () => ({});

export default Services;
